document.addEventListener("DOMContentLoaded", () => {
    const privacyCheckbox = document.getElementById("privacyCheck");
    const checkoutButton = document.getElementById("checkout");
    const privacyCheckRegister = document.getElementById("privacyCheckRegister");
    const registerButton = document.getElementById("registerButton");
    const privacyDrawerCheckRegister = document.getElementById("privacyDrawerCheckRegister");
    const checkoutDrawerButton = document.getElementById("checkoutDrawerButton");

    function toggleButtonState(checkbox, button) {
        if (checkbox && button) {
            button.disabled = !checkbox.checked;
        }
    }

    // 初期状態を設定
    toggleButtonState(privacyCheckbox, checkoutButton);
    toggleButtonState(privacyCheckRegister, registerButton);
    toggleButtonState(privacyDrawerCheckRegister, checkoutDrawerButton);

    // チェックボックスの変更を監視
    if (privacyCheckbox && checkoutButton) {
        privacyCheckbox.addEventListener("change", () => toggleButtonState(privacyCheckbox, checkoutButton));
    }

    if (privacyCheckRegister && registerButton) {
        privacyCheckRegister.addEventListener("change", () => toggleButtonState(privacyCheckRegister, registerButton));
    }

    if (privacyDrawerCheckRegister && checkoutDrawerButton) {
        privacyDrawerCheckRegister.addEventListener("change", () => toggleButtonState(privacyDrawerCheckRegister, checkoutDrawerButton));
    }
});
